import { render } from "./InlineNotice.vue?vue&type=template&id=15cd4246&scoped=true"
import script from "./InlineNotice.vue?vue&type=script&lang=js"
export * from "./InlineNotice.vue?vue&type=script&lang=js"

import "./InlineNotice.vue?vue&type=style&index=0&id=15cd4246&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2653157369/src/mchanga-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15cd4246"]])

export default __exports__